module.exports = __webpack_public_path__ + "img/edge_activites_tennis.57892c14.svg";